@if (googleMapsReady()) {
  <section class="mn_map_view">
    <div class="contmap" style="overflow: hidden">
      <google-map
        #googleMap
        [center]="center()"
        [zoom]="zoom()"
        [options]="options()"
        height="100%"
        (mapClick)="onMapClick($event)"
        width="100%">
        @if (isDriverHomeRoute() === false) {
          <map-marker
            [position]="markerPosition()"
            [icon]="markerIcon()"></map-marker>
        }
        @if (isDriverHomeRoute() === true) {
          @if (isHeatMap() && userHeatCoordinates().length > 0) {
            <map-heatmap-layer
              [data]="userHeatCoordinates()"
              [options]="heatmapOptions()">
            </map-heatmap-layer>

            @for (item of heatMapMarkers(); track $index) {
              <map-marker
                #markerRef="mapMarker"
                [position]="item.position"
                [icon]="transparentMarkerIcon()">
              </map-marker>

              <map-info-window #infoWindow="mapInfoWindow">
                <div
                  class="custom-info-window"
                  style="cursor: pointer"
                  (click)="onMarkerClick(item)">
                  {{ user()?.currency_code }}
                  {{ item.amount | number: '1.3-3' }}
                </div>
              </map-info-window>
            }
          }
          @if (isFlagMap() && markers().length > 0) {
            <map-marker-clusterer
              [zoomOnClick]="true"
              [averageCenter]="true"
              [gridSize]="60"
              [minimumClusterSize]="2"
              [maxZoom]="8"
              [renderer]="customRenderer()!">
              @for (item of markers(); track $item) {
                <map-marker
                  [position]="item.position"
                  [icon]="item.icon"
                  (mapClick)="onMarkerClick(item)">
                </map-marker>
              }
            </map-marker-clusterer>
          }

          @if (clickedMarker() !== null && isDriverHomeRoute()) {
            <map-marker
              [position]="clickedMarker()!.position"
              [icon]="clickedMarker()!.icon"
              (mapClick)="$event.stopPropagation()">
            </map-marker>
          }
        }
      </google-map>
    </div>
  </section>
}
